<template>
  <section id="contato">
    <div class="center-container">
      <div class="title">
        <h2>Reservas e Contato</h2>
        <div class="decoration">
          <div class="dotted-border"></div>
          <i class="fab fa-pagelines"></i>
          <div class="dotted-border"></div>
        </div>
      </div>
      <div class="content">
        <p class="text-center">Preencha o formulário abaixo para receber por email um orçamento da reserva desejada.</p>
        <form v-show="!response" id="formulario" action="contatoPousada.php" method="POST">
          <div class="personal-info">
            <div class="input-group">
              <label for="name" class="required">Nome Completo</label>
              <input id="name" v-model="form.name" @keyup="removeError" ref="name" type="text" name="name" />
              <div class="error-message" data-message="O Nome Completo"></div>
            </div>
            <div class="input-group">
              <label for="email" class="required">Email</label>
              <input id="email" v-model="form.email" @keyup="removeError" type="email" placeholder="seuemail@email.com.br" name="email" />
              <div class="error-message" data-message="O Email"></div>
            </div>
            <div class="input-group">
              <label for="phone" class="required">Telefone / Celular</label>
              <the-mask id="phone" v-model="form.phone" @keyup.native="removeError" name="phone" placeholder="(__) _____-____" :mask="['(##) ####-####', '(##) #####-####']" />
              <div class="error-message" data-message="O Telefone / Celular"></div>
            </div>
            <div class="input-group inputs-aside">
              <div class="input-group">
                <label for="state">Estado</label>
                <input type="text" v-model="form.state" id="state" name="state" value="São Paulo" @input="setState" list="states" />
                <datalist id="states">
                  <option v-for="state in brazilStates" :key="state.id" :value="state.nome">{{state.sigla}} - {{state.nome}}</option>
                </datalist>
              </div>
              <div class="input-group">
                <label for="city">Cidade</label>
                <input type="text" v-model="form.city" id="city" name="city" list="cities"/>
                <datalist id="cities">
                  <option v-for="city in stateCities" :key="city.id" :value="city.nome">{{city.nome}}</option>
                </datalist>
              </div>
            </div>
          </div>
          <div class="booking-info">
            <div class="input-group inputs-aside">
              <div class="input-group">
                <label for="checkin-date">Data de entrada</label>
                <input type="date" :min="minCheckinDate" :value="checkinDate" @input="updateCheckinDate" name="checkin-date">
              </div>
              <div class="input-group">
                <label for="checkout-date">Data de saída</label>
                <input type="date" :min="minCheckoutDate" :value="checkoutDate" @input="updateCheckoutDate" name="checkout-date">
              </div>
            </div>
            <div class="input-group inputs-aside">
              <div class="input-group">
                <label for="adults">Adultos</label>
                <input type="number" min="1" :value="qtdAdults" @input="updateQtdAdults" name="adults">
              </div>
              <div class="input-group">
                <label for="childrens">Crianças</label>
                <input type="number" min="0" :value="qtdChilds" @input="updateQtdChilds" name="childrens">
                <span class="description">Até 12 anos</span>
              </div>
            </div>
            <div class="input-group">
              <label for="msg">Outras Informações</label>
              <span class="description">Caso haja crianças, por favor, especifique as idades neste campo para o orçamento da hospedagem:</span>
              <textarea name="msg" v-model="form.msg" cols="30" rows="5"></textarea>
            </div>
          </div>
        </form>
        <div v-show="!response" class="input-group text-center">
          <button @click="checkForm" class="btn btn-primary">Enviar formulário</button>
        </div>
        <transition name="fade">
          <div id="mail-success-response" v-show="response">
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
            <h2>Email enviado com sucesso!</h2>
            <p>Responderemos o mais breve possível no email informado.</p>
          </div>
        </transition>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import { TheMask } from 'vue-the-mask'

export default {
  name: 'Contact',
  components: {
    TheMask
  },
  data () {
    return {
      minCheckinDate: this.formatDate(new Date()),
      minCheckoutDate: this.formatDate(new Date()),
      brazilStates: [],
      stateCities: [],
      selectedState: {
        nome: 'São Paulo',
        id: 35
      },
      selectedCity: {},
      form: {
        name: '',
        email: '',
        phone: '',
        state: '',
        city: '',
        msg: '',
        errors: 0
      },
      response: false
    }
  },
  computed: {
    ...mapState({
      qtdAdults: state => state.qtdAdults,
      qtdChilds: state => state.qtdChilds,
      checkinDate: state => state.checkinDate,
      checkoutDate: state => state.checkoutDate
    })
  },
  mounted: function () {
    const currentObj = this

    this.$nextTick(() => {
      axios.get('//servicodados.ibge.gov.br/api/v1/localidades/estados')
        .then(function (response) {
          currentObj.brazilStates = response.data
        })
        .catch(function (error) {
          alert(error)
        })
    })
    this.getCities(false)
  },
  methods: {
    updateQtdAdults (e) {
      this.$store.commit('updateQtdAdults', e.target.value)
    },
    updateQtdChilds (e) {
      this.$store.commit('updateQtdChilds', e.target.value)
    },
    formatDate (date) {
      return new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().split('T')[0]
    },
    updateCheckinDate (e) {
      this.$store.commit('updateCheckinDate', e.target.value)
      this.minCheckoutDate = this.checkinDate
    },
    updateCheckoutDate (e) {
      this.$store.commit('updateCheckoutDate', e.target.value)
    },
    setState (e) {
      this.selectedState = this.brazilStates.filter((state) => {
        return this.cleanString(state.nome) === this.cleanString(e.target.value)
      })[0]

      this.getCities(true)
    },
    getCities (focus) {
      this.stateCities = []

      if (!this.selectedState) {
        return
      }

      const currentObj = this

      this.$nextTick(() => {
        axios.get('//servicodados.ibge.gov.br/api/v1/localidades/estados/' + this.selectedState.id + '/municipios')
          .then(function (response) {
            currentObj.stateCities = response.data
            if (focus) {
              document.getElementById('city').focus()
            }
          })
          .catch(function (error) {
            alert(error)
          })
      })
    },
    cleanString (string) {
      return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/\s/g, '')
    },
    checkForm () {
      const form = document.getElementById('formulario')

      this.validateFieldLength(form.phone, 14)
      this.validateField(form.phone)
      this.validateField(form.email)
      this.validateField(form.name)

      if (this.form.errors <= 0) {
        if (!this.checkinDate || !this.checkoutDate) {
          if (confirm('Deseja enviar sem definir uma data de Checkin ou Checkout?')) {
            this.sendForm()
          }
        } else {
          this.sendForm()
        }
      }
    },
    validateField (field) {
      if (!field.value) {
        field.classList.add('error')
        const msg = field.nextSibling
        msg.innerHTML = msg.getAttribute('data-message') + ' não pode ficar em branco'
        msg.classList.add('show')
        field.focus()
        this.form.errors++
        return false
      }

      return true
    },
    validateFieldLength (field, minLength) {
      if (field.value.length < minLength) {
        field.classList.add('error')
        const msg = field.nextSibling
        msg.innerHTML = msg.getAttribute('data-message') + ' deve ser válido'
        msg.classList.add('show')
        this.form.errors++
        field.focus()
        return false
      }

      return true
    },
    removeError (e) {
      e.target.classList.remove('error')
      e.target.nextSibling.classList.remove('show')
      this.form.errors--
    },
    sendForm () {
      const formData = {
        name: this.form.name,
        email: this.form.email,
        phone: this.form.phone,
        state: this.form.state,
        city: this.form.city,
        checkin: this.checkinDate,
        checkout: this.checkoutDate,
        adults: this.qtdAdults,
        childrens: this.qtdChilds,
        msg: this.form.msg
      }

      const currentObj = this

      axios.post('contatoPousada.php', formData)
        .then(function (response) {
          alert('Email enviado!')
          currentObj.response = true
          currentObj.cleanForm()
        })
        .catch(function (error) {
          alert('Erro ao enviar email...')
          currentObj.response = false
          error = null
        })
    },
    cleanForm () {
      this.form.name = ''
      this.form.email = ''
      this.form.phone = ''
      this.form.state = ''
      this.form.city = ''
      this.checkinDate = ''
      this.checkoutDate = ''
      this.qtdAdults = ''
      this.qtdChilds = ''
      this.form.msg = ''
    }
  },
  watch: {
    focusName: function () {
      document.getElementById('name').focus()
    }
  }
}
</script>

<style>
.description {
  font-size: 1.2rem;
  display: block;
  line-height: 1.5rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

#mail-success-response {
  text-align: center;
  padding: 10rem 0;
  border: .4rem dashed #54775e;
  transition: all .2s;
}

.success-checkmark {
  width: 80px;
  height: 115px;
  margin: 0 auto;
}
.success-checkmark .check-icon {
  width: 80px;
  height: 80px;
  position: relative;
  border-radius: 50%;
  box-sizing: content-box;
  border: 4px solid #54775e;
}
.success-checkmark .check-icon::before {
  top: 3px;
  left: -2px;
  width: 30px;
  transform-origin: 100% 50%;
  border-radius: 100px 0 0 100px;
}
.success-checkmark .check-icon::after {
  top: 0;
  left: 30px;
  width: 60px;
  transform-origin: 0 50%;
  border-radius: 0 100px 100px 0;
  animation: rotate-circle 4.25s ease-in;
}
.success-checkmark .check-icon::before, .success-checkmark .check-icon::after {
  content: "";
  height: 100px;
  position: absolute;
  background: #ffffff;
  transform: rotate(-45deg);
}
.success-checkmark .check-icon .icon-line {
  height: 5px;
  background-color: #54775e;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
}
.success-checkmark .check-icon .icon-line.line-tip {
  top: 46px;
  left: 14px;
  width: 25px;
  transform: rotate(45deg);
  animation: icon-line-tip 0.75s;
}
.success-checkmark .check-icon .icon-line.line-long {
  top: 38px;
  right: 8px;
  width: 47px;
  transform: rotate(-45deg);
  animation: icon-line-long 0.75s;
}
.success-checkmark .check-icon .icon-circle {
  top: -4px;
  left: -4px;
  z-index: 10;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  box-sizing: content-box;
  border: 4px solid rgb(84, 119, 94);
}
.success-checkmark .check-icon .icon-fix {
  top: 8px;
  width: 5px;
  left: 26px;
  z-index: 1;
  height: 85px;
  position: absolute;
  transform: rotate(-45deg);
  background-color: #ffffff;
}

@keyframes rotate-circle {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
@keyframes icon-line-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes icon-line-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
</style>
